<ng-template #template>
  <button
    type="button"
    kendoButton
    [iconClass]="'k-button-icon'"
    look="flat"
    [title]="title"
    (click)="onClick($event)"

    [disabled]="disabled"
    [primary]="primary"
    >
    <div class="icon-stack">
      <kendo-icon name="redo" themeColor="primary"></kendo-icon>
      <kendo-icon name="gear" themeColor="primary"></kendo-icon>
    </div>
    {{text | i18n}}
    <ng-content></ng-content>
  </button>
  </ng-template>

